export const INVOICES_BY_PAGE = 2
